<template>
  <div class="home-box">
    <PageTitle :title="pageTitle" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <div class="col-md-12 home-tabs-body">
        <PurchaseOrderEditForm
          :formData="formData"
          :uuid="uuid"
          :proploading="loading"
        />
      </div>
    </v-row>
  </div>
</template>

<script>
import PurchaseOrderEditForm from "@/components/purchaseorder/PurchaseOrderEditForm";
import PageTitle from "@/components/shared/PageTitle";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { PurchaseOrderService } from "@/services/purchaseorder-service.js";

export default {
  name: "EditPurchaseOrder",
  components: {
    PageTitle,
    PurchaseOrderEditForm,
  },
  props: {
    uuid: { type: String, default: null },
  },
  data() {
    return {
      loading: false,
      formData: {
        requisition_id: "",
        supplier_code: "",
        items: [],
        comment: "",
        expected_delivery_date: "",
        status: "pending",
      },
    };
  },
  computed: {
    ...mapGetters({
      vuexloading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
    pageTitle() {
      return "Update Purchase Order";
    },
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
    this.fetchPurchaseOrder();
  },
  methods: {
    async fetchPurchaseOrder() {
      if (!this.uuid) return;
      try {
        this.loading = true;
        const purchaseorder = await PurchaseOrderService.getPurchaseOrderDetails(
          this.uuid
        );
        const items = await PurchaseOrderService.getItemsByPoNumber(
          purchaseorder.po_number
        );
        this.formData.requisition_id = purchaseorder.requisition_id;
        this.formData.supplier_code = purchaseorder.supplier_code;
        this.formData.expected_delivery_date =
          purchaseorder.expected_delivery_date;
        this.formData.comment = purchaseorder.remarks;
        this.formData.items = items;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
